import React, { useEffect } from 'react';

import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/fluxAutomaticLayoutReducer';
import MonthlyDesktop from 'components/Flux/Automatic/Monthly/Desktop';
import MonthlyMobile from 'components/Flux/Automatic/Monthly/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Monthly() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('monthly'));
  });

  if (isMobile) {
    return <MonthlyMobile />;
  }

  return <MonthlyDesktop />;
}
